import React, { useEffect, useState, useRef } from 'react'

import HtmlParser from 'react-html-parser';
import Menu from '../main/Menu';

import {
    settings, settingsPassword, styles, validatePhoneNumber, getError, getResponse, sendMessageCloseCurrentWindow, isUndNullEmpNew,
    getLanguageObj, LoadingSection, checkFileNew, convertFile, checkFileOnLine
} from '../../helpers/UtilsHelper';
import useAuth from '../../auth/useAuth';
import AccountDelete from './AccountDelete';
import Swal from 'sweetalert2';
import { SwalPropertiesClass } from '../../classes/main/swalPropertiesClass';
import { UserService } from '../../services/users/UserService';
import { GlobalFormats } from '../../classes/main/globalFormatClass';
import { AuthContextType } from '../../auth/AuthContext';

const { app, colors, firebase, html, icons, images, messages, labels, react } = settings;
const { urls, documents } = app?.backend;
const { fields: dbFields } = firebase?.firestore;
const { sweetAlert2 } = react;

const currentMethod = 'Profile - function';

export default function Profile({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    const auth = useAuth();
    const role = auth?.account?.role;
    const tokenVzLaML = auth?.account?.tokenVzLaML;
    const userDataId = 'userData';
    const userSecurityId = 'userSecurity';
    const profileUserPictureId = 'profileUserPicture';
    const fileTypes = settings?.app?.fileTypes?.images;

    //#region refs
    const isMount = useRef(true);
    const inpFileImageRef = useRef(null);
    //#endregion refs

    //#region process state
    const [process, setProcess] = useState({
        showLoading: false,
        save: false,
        changePassword: false,
    });
    //#endregion process state

    //#region errors state
    const [errors, setErrors] = useState({
        firstName: '',
        lastName: '',
        phoneNumber: '',
        aiApiKey: '',
        currentPassword: '',
        newPassword: '',
        confirmNewPassword: '',
    });
    //#endregion errors state

    //#region old code
    // const userSettings = { aiApiKey: '' };
    // const [account, setAccount] = useState({ firstName: '', lastName: '', phoneNumber: '', photoName: '', photoURL: '', settings: userSettings });
    //#endregion old code
    const [account, setAccount] = useState({ id: '', firstName: '', lastName: '', email: '', phoneNumber: '', photoIdURL: '', photoURL: '', });
    const [showData, setShowData] = useState(false);
    const [accountDeleteShowModal, setAccountDeleteShowModal] = useState(false);
    const [formAccountDelete, setFormAccountDelete] = useState({});
    const [users, setUsers] = useState([]);
    const [items, setItems] = useState([]);
    const [rates, setRates] = useState([]);
    const [formDataChangePassword, setFormDataChangePassword] = useState({ currentPassword: '', newPassword: '', confirmNewPassword: '' });
    const [showPassword, setShowPassword] = useState(false);
    //#endregion variables

    //#region methods
    //#region helpers
    const setErrorDefault = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setErrorDefault';
        let response = getResponse({ type: 0 });
        try {
            setErrors({
                firstName: '',
                lastName: '',
                phoneNumber: '',
                aiApiKey: '',
                currentPassword: '',
                newPassword: '',
                confirmNewPassword: '',
            });
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const formValidate = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'formValidate';
        let response = getResponse({ type: 0 });
        try {
            if (isUndNullEmpNew({ data: account?.firstName, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, firstName: messages?.thisFieldRequired?.[languageObj?.id] }));
                response = getResponse({ type: 1 });
            }

            if (isUndNullEmpNew({ data: account?.lastName, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, lastName: messages?.thisFieldRequired?.[languageObj?.id] }));
                response = getResponse({ type: 1 });
            }

            if (isUndNullEmpNew({ data: account?.phoneNumber, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, phoneNumber: messages?.thisFieldRequired?.[languageObj?.id] }));
                response = getResponse({ type: 1 });
            } else if (!validatePhoneNumber(account?.phoneNumber)) {
                setErrors(prev => ({ ...prev, phoneNumber: messages?.youMustEnterValidPhoneNumber }));
                response = getResponse({ type: 1 });
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const setPasswordErrorDefault = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setPasswordErrorDefault';
        let response = getResponse({ type: 0 });
        try {
            setErrors(prev => ({
                ...prev,
                currentPassword: '',
                newPassword: '',
                confirmNewPassword: '',
            }));
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const formDataChangePasswordValidate = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'formDataChangePasswordValidate';
        let response = getResponse({ type: 0 });
        try {
            if (isUndNullEmpNew({ data: formDataChangePassword?.currentPassword, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, currentPassword: messages?.thisFieldRequired?.[languageObj?.id] }));
                response = getResponse({ type: 1 });
            } else if (formDataChangePassword.currentPassword.length < settingsPassword.maxLength) {
                setErrors(prev => ({ ...prev, currentPassword: messages?.youMustEnterValidPassword?.[languageObj?.id] }));
                response = getResponse({ type: 1 });
            }

            if (isUndNullEmpNew({ data: formDataChangePassword?.newPassword, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, newPassword: messages?.thisFieldRequired?.[languageObj?.id] }));
                response = getResponse({ type: 1 });
            } else if (formDataChangePassword.newPassword.length < settingsPassword.maxLength) {
                setErrors(prev => ({ ...prev, newPassword: messages?.youMustEnterValidNewPassword?.[languageObj?.id] }));
                response = getResponse({ type: 1 });
            }

            if (isUndNullEmpNew({ data: formDataChangePassword?.confirmNewPassword, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, confirmNewPassword: messages?.thisFieldRequired?.[languageObj?.id] }));
                response = getResponse({ type: 1 });
            } else if (formDataChangePassword.confirmNewPassword.length < settingsPassword.maxLength) {
                setErrors(prev => ({ ...prev, confirmNewPassword: messages?.youMustEnterValidNewPasswordConfirm?.[languageObj?.id] }));
                response = getResponse({ type: 1 });
            } else if (formDataChangePassword.newPassword !== formDataChangePassword.confirmNewPassword) {
                setErrors(prev => ({
                    ...prev,
                    confirmNewPassword: messages?.newPasswordAndNewPasswordConfirmNotMatch?.[languageObj?.id],
                    newPassword: messages?.newPasswordAndNewPasswordConfirmNotMatch?.[languageObj?.id],
                }));
                response = getResponse({ type: 1 });
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const getChangeProfileImage = ({
        e = undefined,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getChangeProfileImage';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault();
            inpFileImageRef?.current?.click();
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }
    //#endregion helpers

    //#region roots
    const getData = async ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            setFormDataChangePassword({ currentPassword: '', newPassword: '', confirmNewPassword: '' });

            if (!auth?.isLoged()) {
                response = getResponse({ type: 1, msgText_: `${messages?.youMustLogInAccessThisSection?.[languageObj?.id]}`, urlGoTo: urls?.home });
                return;
            }

            setProcess(prev => ({ ...prev, showLoading: true }));

            //#region get profile data
            response = await UserService.getProfile({
                uid: auth?.account?.uid,
                // token: auth?.account?.tokenVzLaML?.token,
                token: tokenVzLaML?.token,
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion get profile data

            //#region set data
            let account_ = AuthContextType?.account;
            account_ = response?.result?.account;
            setAccount(account_);
            setUsers(response?.result?.users || []);
            setItems(response?.result?.items || []);
            setRates(response?.result?.rates || []);
            //#endregion set data

            // if (isUndNullEmpNew({ data: account_?.photoURL, subMethod: currentMethod })?.result ||
            //     account_?.photoURL?.includes(images?.noImage)) {
            //     setAccount(prev => ({ ...prev, photoURL: `${app?.url}${images?.noImage}` }));
            //     return;
            // }

            response = await checkFileOnLine({
                url: account_?.photoURL,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
            if (!response?.isSuccess) return;
            if (response?.isSuccess && !response?.isWarning) setAccount(prev => ({ ...prev, photoURL: account_?.photoURL }));
            if (response?.isWarning) {
                setAccount(prev => ({ ...prev, photoURL: `${app?.url}${images?.noImage}` }))
                response.msgText = ''
            };
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));
            setShowData(response?.isSuccess && !response?.isWarning);

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const editProfile = async ({
        e = undefined,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'editProfile';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault();

            //#region error default / form validate
            response = setErrorDefault({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = formValidate({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion error default / form validate

            setProcess(prev => ({ ...prev, showLoading: true, save: true }));

            //#region update data (account / firebase)
            response = await UserService.update({
                id: account?.id,
                // token: auth?.account?.tokenVzLaML?.token,
                token: tokenVzLaML?.token,
                data: {
                    firstName: account?.firstName,
                    lastName: account?.lastName,
                    phoneNumber: account?.phoneNumber,
                    //#region old code
                    // photoName: isUndNullEmpNew({ data: account?.photoName, subMethod: currentMethod })?.result ? `` : account?.photoName,
                    // photoURL: isUndNullEmpNew({ data: account?.photoURL, subMethod: currentMethod })?.result ? `${app?.url}${images?.noImage}` : account?.photoURL,
                    //#endregion old code
                    photoIdURL: isUndNullEmpNew({ data: account?.photoIdURL, subMethod: currentMethod })?.result ? `` : account?.photoIdURL,
                    photoURL: isUndNullEmpNew({ data: account?.photoURL, subMethod: currentMethod })?.result ? `${app?.url}${images?.noImage}` : account?.photoURL,
                    //#region old code
                    // settings: account?.settings || userSettings,
                    //#endregion old code
                    isPartialUpdate: true,
                },
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return;

            const accountMl_ = response?.result?.accountML;
            let accountFirebase_ = response?.result?.accountFirebase;
            setAccount(accountMl_);
            //#endregion update data (account / firebase)

            //#region set accountFirebase
            response = auth?.setAccountLocal({
                accountML: accountMl_,
                accountFirebase: accountFirebase_,
                // token: auth?.account?.tokenVzLaML,
                token: tokenVzLaML,
                role: role,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return;

            accountFirebase_ = response?.result?.accountFirebase || {};
            //#endregion set accountFirebase

            //#region update data (local / firebase)
            response = auth?.updateAccountLocal({
                accountNew: accountFirebase_,
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion update data (local / firebase)

            response = getResponse({
                type: 0,
                msgText_: messages?.processCompletedSuccessfully?.[languageObj?.id],
            });
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, save: false, showLoading: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const changeProfileImage = async ({
        e = undefined,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'changeProfileImage';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault();

            //#region variables
            let file_ = {};
            let value_ = '';
            let fileName_ = '';
            let photoURL = '';
            let photoIdURL = '';
            // let accountMl_ = {};
            let fileString_ = '';
            let accountFirebase_ = {};
            //#endregion variables

            value_ = e?.target?.value;
            file_ = e?.target?.files?.[0];

            if (isUndNullEmpNew({ data: value_, subMethod: currentMethod })?.result) return;

            setProcess(prev => ({ ...prev, showLoading: true, save: true }));

            //#region check file
            response = checkFileNew({
                fileType: file_.type,
                fileSize: file_.size,
                fileAllowedTypes: fileTypes,
                fileMaxSize: settings.app.fileSize.max,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion check file

            //#region convert file
            response = await convertFile.toBase64URL({
                file: file_,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return;

            fileString_ = response.result;
            //#endregion convert file

            //#region upload / delete data (image / file)
            //#region old code
            // if (!isUndNullEmpNew({ data: account?.photoName, subMethod: currentMethod })?.result) {
            //#endregion old code
            if (!isUndNullEmpNew({ data: account?.photoIdURL, subMethod: currentMethod })?.result) {
                //#region with existing image — replace
                //#region old code
                // fileName_ = account?.photoName;
                //#endregion old code
                fileName_ = account?.photoIdURL;
                response = await UserService.fileUploadReplace({
                    folder: documents?.accounts,
                    fileName: fileName_,
                    fileString: fileString_,
                    // token: auth?.account?.tokenVzLaML?.token,
                    token: tokenVzLaML?.token,
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) return;

                //#region old code
                // photoURL = response.result;
                //#endregion old code
                //#region old code
                // photoURL = response?.result?.photoURL;
                // photoIdURL = response?.result?.photoIdURL;
                //#endregion old code
                photoURL = response?.result?.url || '';
                photoIdURL = response?.result?.id || '';
                //#endregion with existing image — replace
            } else {
                //#region no image — upload new
                fileName_ = `${account?.id}.${file_.name.split('.').pop()}`;
                response = await UserService.fileUpload({
                    folder: documents?.accounts,
                    fileName: fileName_,
                    fileString: fileString_,
                    // token: auth?.account?.tokenVzLaML?.token,
                    token: tokenVzLaML?.token,
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) return;

                //#region old code
                // photoURL = response?.result?.photoURL || response?.result?.url;
                // photoIdURL = response?.result?.photoIdURL || response?.result?.id;
                //#endregion old code
                photoURL = response?.result?.url || '';
                photoIdURL = response?.result?.id || '';
                //#endregion no image — upload new
            }
            //#endregion upload / delete data (image / file)

            //#region update data (account — photo)
            //#region old code
            // response = await UserService.update({
            //     id: account?.id,
            //     // token: auth?.account?.tokenVzLaML?.token,
            //     token: tokenVzLaML?.token,
            //     data: {
            //         //#region old code
            //         // photoName: fileName_,
            //         //#endregion old code
            //         photoURL: photoURL,
            //         photoIdURL: photoIdURL,
            //         isPartialUpdate: true,
            //     },
            //     subMethod: currentMethod,
            // });
            // if (!response?.isSuccess || response?.isWarning) return;

            // accountMl_ = response?.result?.accountML;
            // accountFirebase_ = response?.result?.accountFirebase;
            // //#region old code
            // // accountFirebase_.role = {
            // //     role: accountMl_?.role,
            // //     roleId: accountMl_?.roleId,
            // //     roleDate: accountMl_?.roleDate,
            // //     roleUserId: accountMl_?.roleUserId,
            // // };
            // //#endregion old code
            // accountFirebase_.role = role;
            // accountFirebase_.tokenVzLaML = tokenVzLaML;
            // setAccount({
            //     id: accountMl_?.id || '',
            //     firstName: accountMl_?.firstName || '',
            //     lastName: accountMl_?.lastName || '',
            //     email: accountMl_?.email || '',
            //     phoneNumber: accountMl_?.phoneNumber || '',
            //     photoURL: accountMl_?.photoURL || '',
            //     photoIdURL: accountMl_?.photoIdURL || '',
            // });
            //#endregion old code

            accountFirebase_ = auth?.account;
            accountFirebase_.photoURL = photoURL;

            setAccount(prev => ({ ...prev, photoURL: photoURL, photoIdURL: photoIdURL, }));
            //#endregion update data (account — photo)

            //#region update data (account firebase)
            response = auth?.updateAccountLocal({
                accountNew: accountFirebase_,
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion update data (account firebase)

            response = getResponse({
                type: 0,
                msgText_: messages?.processCompletedSuccessfully?.[languageObj?.id],
            });
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            if (inpFileImageRef?.current) inpFileImageRef.current.value = '';

            setProcess(prev => ({ ...prev, save: false, showLoading: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const changePassword = async ({
        e = undefined,
        subMethod = '',
    } = {}) => {
        const currentMethod_ = 'changePassword';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault();

            setShowPassword(false);

            //#region error default / form validate
            response = setPasswordErrorDefault({ subMethod: currentMethod_ });
            if (!response?.isSuccess || response?.isWarning) return;

            response = formDataChangePasswordValidate({ subMethod: currentMethod_ });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion error default / form validate

            setProcess(prev => ({ ...prev, showLoading: true, changePassword: true }));

            //#region change password
            response = await UserService.changePassword({
                email: auth?.account?.email,
                currentPassword: formDataChangePassword.currentPassword,
                newPassword: formDataChangePassword.newPassword,
                // token: auth?.account?.tokenVzLaML?.token,
                token: tokenVzLaML?.token,
                subMethod: currentMethod_,
            });
            if (!response?.isSuccess || response?.isWarning) return;

            setFormDataChangePassword({ currentPassword: '', newPassword: '', confirmNewPassword: '' });
            //#endregion change password

            response = getResponse({ type: 0 });
            response.msgText = `${messages?.thePasswordHasBeenChangedSuccessfully?.[languageObj?.id]}<br/>`;
            response.msgText += `${messages?.forSecurityReasonsYouMustLogInWithTheNewPassword?.[languageObj?.id]}`;
            response.urlGoTo = `${urls?.login}`;
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod_, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, changePassword: false, showLoading: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod_,
            });
        }
    }

    const getAccountDelete = async ({
        e = undefined,
        subMethod = '',
    } = {}) => {
        e?.preventDefault();
        const currentMethod_ = 'getAccountDelete';
        let response = getResponse({ type: 0 });
        try {
            //#region show message
            let msgTextObj = {
                one: `${messages?.areYouSureDeleteThis?.[languageObj?.id]}`,
                two: `${labels?.account?.[languageObj?.id]}<br/>`,
                three: messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id],
            };

            let swalProperties = SwalPropertiesClass?.getClass();
            swalProperties = {
                icon: sweetAlert2?.icons?.warning,
                title: msgTextObj?.one,
                html: `${msgTextObj?.two}${msgTextObj?.three}`,
                timer: null,
                backdrop: true,
                confirmButtonColor: colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: true,
                cancelButtonColor: colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                customClass: {
                    popup: html?.popup,
                    confirmButton: html?.buttons?.primary,
                    cancelButton: html?.buttons?.secondary,
                },
                didOpen: () => {
                    Swal.hideLoading();
                },
                preConfirm: async () => {
                    let preConfirmResponse = getResponse({ type: 0 });
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal.update({
                            icon: sweetAlert2?.icons?.info,
                            title: `${messages?.processing?.[languageObj?.id]}`,
                            html: `${msgTextObj?.two}`,
                            showConfirmButton: false,
                        });

                        setFormAccountDelete({
                            email: auth?.account?.email,
                            password: '',
                        });
                        setAccountDeleteShowModal(true);

                        preConfirmResponse = getResponse({
                            type: 0,
                            msgText_: messages?.processCompletedSuccessfully?.[languageObj?.id],
                        });
                    } catch (ex) {
                        preConfirmResponse = getError({ ex: ex, response: preConfirmResponse, currentMethod_: currentMethod_, subMethod_: subMethod });
                    }
                    return preConfirmResponse;
                },
            };

            Swal.fire({ ...swalProperties });
            //#endregion show message
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod_, subMethod_: subMethod });
            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod_,
            });
        }
    }
    //#endregion roots

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => { isMount.current = false; };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <div>
            <Menu viewName={'home'} process={''} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.profile?.[languageObj?.id]}</h4>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href={urls?.home} className='link-primary-bold'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.profile?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        <div className='row'>
                            <div className='col-12 col-md-3 mb-4'>
                                <div className='card border-0 shadow-lg login-card' style={{ borderRadius: '8px', overflow: 'visible' }}>
                                    <LoadingSection alt='loadingSection'
                                        className='overlay dark text-white'
                                        height={20}
                                        hidden={!process?.showLoading}
                                        width={20}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />
                                    <div className='card-body box-profile pt-4'>
                                        <div className='text-center' id={profileUserPictureId}>
                                            <a href={`#${profileUserPictureId}`}>
                                                <img className='profile-user-img img-fluid img-circle'
                                                    style={{ ...styles.profileUserPicture, cursor: 'pointer', border: '3px solid var(--color-primary-border)' }}
                                                    src={showData ? isUndNullEmpNew({ data: account?.photoURL, subMethod: '', })?.result ? images?.noImage : account?.photoURL : images?.noImage}
                                                    alt='userProfilePicture'
                                                    onClick={(e) => getChangeProfileImage({ e: e, subMethod: 'imgUserPicture', })} />
                                            </a>
                                        </div>
                                        <a href={`#${profileUserPictureId}`}>
                                            <p className='link-primary text-center mt-2 mb-3'
                                                style={{ fontSize: 11, fontWeight: '600', cursor: 'pointer' }}
                                                onClick={(e) => getChangeProfileImage({ e: e, subMethod: 'pUserPicture', })}>
                                                [{labels?.clickToChangePicture?.[languageObj?.id]}]
                                            </p>
                                        </a>
                                        <h4 className='profile-username text-center font-weight-bold text-dark mb-1'>{`${showData ? account?.firstName : '---'} ${showData ? account?.lastName : '---'}`}</h4>
                                        <p className='text-muted text-center mb-4'><i className={`${icons?.fasFa?.userTag} mr-1 text-primary`} /> {showData ? account?.role : '---'}</p>
                                        <ul className='list-group list-group-unbordered mb-3'>
                                            <li className='list-group-item d-flex justify-content-between align-items-center border-top-0 px-0'>
                                                <span><i className={`${icons?.fasFa?.users} mr-2 text-primary`} /> <b>{labels?.accounts?.[languageObj?.id]}</b></span>
                                                <a className='badge badge-pill badge-primary px-3 py-2 font-weight-bold shadow-sm' href={urls?.accounts}>{showData ? (users?.length || 0) : 0}</a>
                                            </li>
                                            <li className='list-group-item d-flex justify-content-between align-items-center px-0'>
                                                <span><i className={`${icons?.fasFa?.listUl} mr-2 text-primary`} /> <b>{labels?.items?.[languageObj?.id]}</b></span>
                                                <a className='badge badge-pill badge-primary px-3 py-2 font-weight-bold shadow-sm' href='/process'>{showData ? (items?.length || 0) : 0}</a>
                                            </li>
                                            <li className='list-group-item d-flex justify-content-between align-items-center border-bottom-0 px-0'>
                                                <span><i className={`${icons?.fasFa?.chartBar} mr-2 text-primary`} /> <b>{labels?.rate?.[languageObj?.id]}</b></span>
                                                <a className='badge badge-pill badge-primary px-3 py-2 font-weight-bold shadow-sm' href='/rates'>{showData ? (rates?.length || 0) : 0}</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className='col-12 col-md-9 mb-4'>
                                <div className='card border-0 shadow-lg login-card' style={{ borderRadius: '8px', overflow: 'visible' }}>
                                    <LoadingSection alt='loadingSection'
                                        className='overlay dark text-white'
                                        height={20}
                                        hidden={!process?.showLoading}
                                        width={20}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    <div className='card-header p-2 bg-white border-bottom-0 pt-3 px-3'>
                                        <ul className='nav nav-pills'>
                                            <li className='nav-item' data-toggle='tooltip' title={labels?.profile?.[languageObj?.id]}>
                                                <a className='nav-link active' href={`#${userDataId}`} data-toggle='tab' style={{ borderRadius: '8px' }}>
                                                    <i className={`${icons?.userEdit} mr-1`} /> {labels?.profile?.[languageObj?.id]}
                                                </a>
                                            </li>
                                            <li className='nav-item' data-toggle='tooltip' title={labels?.changePassword?.[languageObj?.id]}>
                                                <a className='nav-link' href={`#${userSecurityId}`} data-toggle='tab' style={{ borderRadius: '8px' }}>
                                                    <i className={`${icons?.fasFa?.key} mr-1`} /> {labels?.changePassword?.[languageObj?.id]}
                                                </a>
                                            </li>
                                            {/* <li className='nav-item' data-toggle='tooltip' title={labels?.settings?.[languageObj?.id]}>
                                                <a className='nav-link' href={`#${userSettingsId}`} data-toggle='tab' style={{ borderRadius: '8px' }}>
                                                    <i className={`${icons?.fasFa?.cogs} mr-1`} /> {labels?.settings?.[languageObj?.id]}
                                                </a>
                                            </li> */}
                                        </ul>
                                    </div>

                                    <div className='card-body pt-3'>
                                        <div className='tab-content'>

                                            <div className='active tab-pane' id={userDataId}>

                                                <form className='form-horizontal' method='post' onSubmit={(e) => editProfile({ e: e, subMethod: 'onSubmit - form', })}>
                                                    <div className='row'>
                                                        <div className='col-12 col-md-6 mb-3'>
                                                            <div className='form-group'>
                                                                <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                                                    {labels?.firstName?.[languageObj?.id]}
                                                                </label>
                                                                <div className='position-relative'>
                                                                    <i className={`${icons?.fasFa?.user} position-absolute input-icon-left`} />
                                                                    <input autoFocus
                                                                        className='form-control border-0 shadow-sm form-input-icon'
                                                                        onChange={(e) => setAccount({ ...account, [dbFields?.firstName]: e.target.value, })}
                                                                        onFocus={() => setErrors(prev => ({ ...prev, firstName: '' }))}
                                                                        placeholder={labels?.firstName?.[languageObj?.id]}
                                                                        title={labels?.firstName?.[languageObj?.id]}
                                                                        value={showData ? (account?.firstName || '') : '---'}
                                                                        disabled={process?.showLoading} />
                                                                </div>
                                                                {errors?.firstName && <div className='form-text mt-1 form-error-text'>{HtmlParser(errors?.firstName)}</div>}
                                                            </div>
                                                        </div>

                                                        <div className='col-12 col-md-6 mb-3'>
                                                            <div className='form-group'>
                                                                <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                                                    {labels?.lastName?.[languageObj?.id]}
                                                                </label>
                                                                <div className='position-relative'>
                                                                    <i className={`${icons?.fasFa?.user} position-absolute input-icon-left`} />
                                                                    <input className='form-control border-0 shadow-sm form-input-icon'
                                                                        onChange={(e) => setAccount({ ...account, [dbFields?.lastName]: e.target.value, })}
                                                                        onFocus={() => setErrors(prev => ({ ...prev, lastName: '' }))}
                                                                        placeholder={labels?.lastName?.[languageObj?.id]}
                                                                        title={labels?.lastName?.[languageObj?.id]}
                                                                        value={showData ? (account?.lastName || '') : '---'}
                                                                        disabled={process?.showLoading} />
                                                                </div>
                                                                {errors?.lastName && <div className='form-text mt-1 form-error-text'>{HtmlParser(errors?.lastName)}</div>}
                                                            </div>
                                                        </div>

                                                        <div className='col-12 col-md-6 mb-3'>
                                                            <div className='form-group'>
                                                                <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                                                    {labels?.phoneNumber?.[languageObj?.id]}
                                                                </label>
                                                                <div className='position-relative'>
                                                                    <i className={`${icons?.fasFa?.mobileAlt} position-absolute input-icon-left`} />
                                                                    <input className='form-control border-0 shadow-sm form-input-icon'
                                                                        onChange={(e) => setAccount({ ...account, [dbFields?.phoneNumber]: e.target.value, })}
                                                                        onFocus={() => setErrors(prev => ({ ...prev, phoneNumber: '' }))}
                                                                        placeholder={labels?.phoneNumber?.[languageObj?.id]}
                                                                        title={labels?.phoneNumber?.[languageObj?.id]}
                                                                        value={showData ? (account?.phoneNumber || '') : '---'}
                                                                        disabled={process?.showLoading} />
                                                                </div>
                                                                {errors?.phoneNumber && <div className='form-text mt-1 form-error-text'>{HtmlParser(errors?.phoneNumber)}</div>}
                                                            </div>
                                                        </div>

                                                        <div className='col-12 col-md-6 mb-3'>
                                                            <div className='form-group'>
                                                                <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                                                    {labels?.email?.[languageObj?.id]}
                                                                </label>
                                                                <div className='position-relative'>
                                                                    <i className={`${icons?.fasFa?.envelope} position-absolute input-icon-left`} />
                                                                    <input className='form-control border-0 shadow-sm form-input-icon bg-light'
                                                                        placeholder={labels?.email?.[languageObj?.id]}
                                                                        title={labels?.email?.[languageObj?.id]}
                                                                        value={showData ? (account?.email || '') : '---'} readOnly />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-12' style={{ display: 'none' }}>
                                                            <input type='file'
                                                                ref={inpFileImageRef}
                                                                onChange={(e) => changeProfileImage({ e: e, subMethod: 'inpFileImage', })} />
                                                        </div>

                                                        <div className='col-12 mt-3 d-flex justify-content-end align-items-center' style={{ gap: '8px' }}>
                                                            <button className='btn btn-danger shadow-sm font-weight-bold px-4 btn-general'
                                                                type='button'
                                                                data-title={labels?.deleteAccount?.[languageObj?.id]}
                                                                disabled={process?.showLoading}
                                                                onClick={(e) => getAccountDelete({ e: e, subMethod: 'btnDeleteAccount', })}>
                                                                <i className={`${icons?.fasFa?.userTimes || 'fas fa-user-times'} mr-1`} /> {labels?.deleteAccount?.[languageObj?.id]}
                                                            </button>
                                                            <button className='btn btn-primary shadow-sm font-weight-bold px-4 btn-primary'
                                                                type='submit'
                                                                disabled={process?.showLoading}
                                                                data-title={labels?.save?.[languageObj?.id]}>
                                                                {!process?.save ? (
                                                                    <i className={`${icons?.fasFa?.save} mr-1`} />
                                                                ) : (
                                                                    <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                                )} {labels?.save?.[languageObj?.id]}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </form>

                                            </div>

                                            <div className='tab-pane' id={userSecurityId} >

                                                <form className='form-horizontal' method='post' onSubmit={(e) => changePassword({ e: e, subMethod: 'onSubmit - form', })}>
                                                    <div className='row'>
                                                        <div className='col-12 col-md-6 mb-3'>
                                                            <div className='form-group'>
                                                                <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                                                    {labels?.currentPassword?.[languageObj?.id]}
                                                                </label>
                                                                <div className='position-relative'>
                                                                    <span className='position-absolute input-icon-left'
                                                                        style={{ cursor: 'pointer', zIndex: 10 }}
                                                                        onClick={() => setShowPassword(!showPassword)}>
                                                                        <i className={showPassword ? icons?.fasFa?.eye : icons?.fasFa?.eyeSlash}></i>
                                                                    </span>
                                                                    <input className='form-control border-0 shadow-sm form-input-icon'
                                                                        placeholder={labels?.currentPassword?.[languageObj?.id]}
                                                                        title={labels?.currentPassword?.[languageObj?.id]}
                                                                        type={showPassword ? 'text' : 'password'}
                                                                        autoComplete='current-password'
                                                                        value={formDataChangePassword?.currentPassword || ''}
                                                                        disabled={process?.showLoading}
                                                                        onChange={(e) => setFormDataChangePassword(prev => ({ ...prev, currentPassword: e.target.value }))}
                                                                        onFocus={() => setErrors(prev => ({ ...prev, currentPassword: '' }))} />
                                                                </div>
                                                                {errors?.currentPassword && <div className='form-text mt-1 form-error-text'>{HtmlParser(errors?.currentPassword)}</div>}
                                                            </div>
                                                        </div>
                                                        <div className='col-12 col-md-6 mb-3'>
                                                            <div className='form-group'>
                                                                {/* <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                                                    {labels?.account?.[languageObj?.id]}
                                                                </label> */}
                                                                <div className='position-relative'>
                                                                    {/* <span className='position-absolute input-icon-left'>
                                                                        <i className={icons?.fasFa?.user}></i>
                                                                    </span> */}
                                                                    <input className='form-control border-0 shadow-sm form-input-icon'
                                                                        placeholder={labels?.email?.[languageObj?.id]}
                                                                        title={labels?.email?.[languageObj?.id]}
                                                                        type={'text'}
                                                                        autoComplete='username'
                                                                        value={account?.email || ''}
                                                                        disabled={true}
                                                                        hidden={true} />
                                                                </div>
                                                                {/* {errors?.currentPassword && <div className='form-text mt-1 form-error-text'>{HtmlParser(errors?.currentPassword)}</div>} */}
                                                            </div>
                                                        </div>

                                                        <div className='col-12 col-md-6 mb-3'>
                                                            <div className='form-group'>
                                                                <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                                                    {labels?.newPassword?.[languageObj?.id]}
                                                                </label>
                                                                <div className='position-relative'>
                                                                    <span className='position-absolute input-icon-left'
                                                                        style={{ cursor: 'pointer', zIndex: 10 }}
                                                                        onClick={() => setShowPassword(!showPassword)}>
                                                                        <i className={showPassword ? icons?.fasFa?.eye : icons?.fasFa?.eyeSlash}></i>
                                                                    </span>
                                                                    <input className='form-control border-0 shadow-sm form-input-icon'
                                                                        placeholder={labels?.newPassword?.[languageObj?.id]}
                                                                        title={labels?.newPassword?.[languageObj?.id]}
                                                                        type={showPassword ? 'text' : 'password'}
                                                                        autoComplete='new-password'
                                                                        value={formDataChangePassword?.newPassword || ''}
                                                                        disabled={process?.showLoading}
                                                                        onChange={(e) => setFormDataChangePassword(prev => ({ ...prev, newPassword: e.target.value }))}
                                                                        onFocus={() => setErrors(prev => ({ ...prev, newPassword: '' }))} />
                                                                </div>
                                                                {errors?.newPassword && <div className='form-text mt-1 form-error-text'>{HtmlParser(errors?.newPassword)}</div>}
                                                            </div>
                                                        </div>

                                                        <div className='col-12 col-md-6 mb-3'>
                                                            <div className='form-group'>
                                                                <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                                                    {labels?.confirmNewPassword?.[languageObj?.id]}
                                                                </label>
                                                                <div className='position-relative'>
                                                                    <span className='position-absolute input-icon-left'
                                                                        style={{ cursor: 'pointer', zIndex: 10 }}
                                                                        onClick={() => setShowPassword(!showPassword)}>
                                                                        <i className={showPassword ? icons?.fasFa?.eye : icons?.fasFa?.eyeSlash}></i>
                                                                    </span>
                                                                    <input className='form-control border-0 shadow-sm form-input-icon'
                                                                        placeholder={labels?.confirmNewPassword?.[languageObj?.id]}
                                                                        title={labels?.confirmNewPassword?.[languageObj?.id]}
                                                                        type={showPassword ? 'text' : 'password'}
                                                                        autoComplete='new-password'
                                                                        value={formDataChangePassword?.confirmNewPassword || ''}
                                                                        disabled={process?.showLoading}
                                                                        onChange={(e) => setFormDataChangePassword(prev => ({ ...prev, confirmNewPassword: e.target.value }))}
                                                                        onFocus={() => setErrors(prev => ({ ...prev, confirmNewPassword: '' }))} />
                                                                </div>
                                                                {errors?.confirmNewPassword && <div className='form-text mt-1 form-error-text'>{HtmlParser(errors?.confirmNewPassword)}</div>}
                                                            </div>
                                                        </div>

                                                        <div className='col-12 mt-3 d-flex justify-content-end'>
                                                            <button data-title={labels?.save?.[languageObj?.id]}
                                                                disabled={process?.showLoading}
                                                                className='btn btn-primary shadow-sm font-weight-bold px-4 btn-primary'
                                                                type='submit'>
                                                                {!process?.changePassword ? (
                                                                    <i className={`${icons?.fasFa?.save} mr-1`} />
                                                                ) : (
                                                                    <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                                )} {labels?.save?.[languageObj?.id]}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </form>

                                            </div>

                                            {/* <div className='tab-pane' id={userSettingsId} >

                                                <form className='form-horizontal' method='post' onSubmit={(e) => editProfile({ e: e, subMethod: 'onSubmit - form', })}>
                                                    <div className='row'>
                                                        <div className='col-12 mb-3'>
                                                            <div className='form-group'>
                                                                <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                                                    {labels?.aiApiKey?.[languageObj?.id]}
                                                                </label>
                                                                <div className='position-relative'>
                                                                    <i className={`${icons?.fasFa?.spellCheck || 'fas fa-spell-check'} position-absolute input-icon-left`} />
                                                                    <input autoFocus
                                                                        className='form-control border-0 shadow-sm form-input-icon'
                                                                        onChange={(e) => setAccount({ ...account, [dbFields?.settings]: { ...account?.settings, [dbFields?.aiApiKey]: e.target.value }, })}
                                                                        onFocus={() => setErrors(prev => ({ ...prev, aiApiKey: '' }))}
                                                                        placeholder={labels?.aiApiKey?.[languageObj?.id]}
                                                                        title={labels?.aiApiKey?.[languageObj?.id]}
                                                                        value={showData ? account?.settings?.aiApiKey : '---'}
                                                                        disabled={process?.showLoading} />
                                                                </div>
                                                                {errors?.aiApiKey && <div className='form-text mt-1 form-error-text'>{HtmlParser(errors?.aiApiKey)}</div>}
                                                            </div>
                                                        </div>

                                                        <div className='col-12 mt-3 d-flex justify-content-end'>
                                                            <button data-title={labels?.save?.[languageObj?.id]}
                                                                disabled={process?.showLoading}
                                                                className='btn btn-primary shadow-sm font-weight-bold px-4 btn-primary'
                                                                type='submit'>
                                                                {!process?.save ? (
                                                                    <i className={`${icons?.fasFa?.save} mr-1`} />
                                                                ) : (
                                                                    <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                                )} {labels?.save?.[languageObj?.id]}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </form>

                                            </div> */}

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>

                    {accountDeleteShowModal && (
                        <AccountDelete processValues={{
                            $: window.$,
                            auth,
                            account: formAccountDelete,
                            setAccount: setFormAccountDelete,
                            showModal: accountDeleteShowModal,
                            setShowModal: setAccountDeleteShowModal,
                        }} />
                    )}
                </section>

            </div>
        </div>
    )
}